import { z } from "zod";
import { StandardResponseSchema, pageSchema } from "@/helpers/types";
import { api } from "@/helpers/api_helper";
import { BaseUserSchema } from "@/types";

// Schema for owner in filters
export const DbtDocsOwnerSchema = z.object({
  created_at: z.string(),
  display_name: z.string().nullable(),
  email: z.string(),
  first_name: z.string().nullable(),
  id: z.number(),
  is_active: z.boolean(),
  is_invited: z.boolean(),
  is_onboarded: z.boolean(),
  is_verified: z.boolean(),
  last_name: z.string().default(""),
  phone: z.string().default(""),
  role_title: z.string().nullable(),
  uuid: z.string(),
});

export const DbtDocsFiltersSchema = z.object({
  owners: z.array(DbtDocsOwnerSchema),
  names: z.array(z.string()),
});

export type DbtDocsFilters = z.infer<typeof DbtDocsFiltersSchema>;

// Schema for a single dbt docs share item
export const DbtDocsShareSchema = z.object({
  share_id: z.coerce.string(),
  name: z.string(),
  description: z.string().nullable().optional(),
  expires_at: z.string().nullable().optional(),
  created_at: z.string(),
  updated_at: z.string(),
  owner: z.number(),
  open_conversations: z.number(),
  resolved_conversations: z.number(),
  user: BaseUserSchema.extend({ role_title: z.string().nullish() }),
  project_name: z.string(),
  project_metadata: z.record(z.unknown()),
  conversation_group: z.array(z.unknown()).nullable().optional(),
});

export type DbtDocsShare = z.infer<typeof DbtDocsShareSchema>;

// Schema for paginated list response
export const DbtDocsShareListResponseSchema = pageSchema(DbtDocsShareSchema);

export type DbtDocsShareListResponse = z.infer<typeof DbtDocsShareListResponseSchema>;

// Schema for delete response
export const DbtDocsDeleteResponseSchema = z.object({
  ok: z.boolean(),
});

export type DbtDocsDeleteResponse = z.infer<typeof DbtDocsDeleteResponseSchema>;

// API functions
export const getDbtDocsShareList = (params: Record<string, unknown>) =>
  api.get<DbtDocsShareListResponse>(
    `dbt/dbt_docs_share`,
    params,
    0,
    DbtDocsShareListResponseSchema
  );

// DBT Docs Share List Params
export interface GetDbtDocsShareListParams {
  page?: number;
  size?: number;
  sort_key?: string;
  sort_order?: string;
  names?: string[];
  owners?: number[];
}

// DBT Docs Share URL Response
export interface DbtDocsShareUrlResponse {
  app_url: string;
}

export type CurrentUserResponse = z.infer<typeof BaseUserSchema>;

// DBT Docs Share URL Response Schema
export const DbtDocsShareUrlResponseSchema = z.object({
  name: z.string(),
  manifest_presigned_url: z.string(),
  catalog_presigned_url: z.string(),
  app_url: z.string(),
});

// Re-export StandardResponseSchema as StandardApiResponseSchema for backward compatibility
export { StandardResponseSchema as StandardApiResponseSchema } from "@/helpers/types";
export type StandardApiResponse = z.infer<typeof StandardResponseSchema>;
